module.exports = {
      id: "calendar-usage",
      viewBox: "0 0 17.552 17.301",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#calendar",
      toString: function () {
        return this.url;
      }
    }